import { useParams } from 'react-router-dom';

export const useIsPortfolioTracker = () => {
  const { portfolioId } = useParams<{ portfolioId?: string }>();
  return !!portfolioId;
};
